import { useState } from 'react';
import { StarIcon as StarOutline } from '@heroicons/react/24/outline';
import { StarIcon as StarSolid } from '@heroicons/react/24/solid';
import './task-grade.css';

const STARS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const TaskGradeStars = ({
    id = 'task-grade',
    label = 'Calificación',
    value = null,
    onChange,
    disabled = false,
    readOnly = false,
    error = null,
    required = false,
}) => {
    const [hover, setHover] = useState(0);
    const selected = Number.isInteger(value) ? value : 0;
    const display = hover || selected;
    const interactive = !disabled && !readOnly && typeof onChange === 'function';

    const setGrade = (next) => {
        if (!interactive) return;
        onChange(next);
    };

    return (
        <div className="task-grade">
            {label ? (
                <span className="task-grade__label" id={`${id}-label`}>
                    {label}
                    {required ? <span className="task-grade__required" aria-hidden="true">*</span> : null}
                </span>
            ) : null}

            <div
                className="task-grade__row"
                role={interactive ? 'radiogroup' : 'img'}
                aria-labelledby={label ? `${id}-label` : undefined}
                aria-label={label ? undefined : 'Calificación'}
                onMouseLeave={() => setHover(0)}
            >
                {STARS.map((star) => {
                    const active = display >= star;
                    const Icon = active ? StarSolid : StarOutline;
                    if (!interactive) {
                        return (
                            <span
                                key={star}
                                className={`task-grade__star${active ? ' is-active' : ''}`}
                                aria-hidden="true"
                            >
                                <Icon />
                            </span>
                        );
                    }
                    return (
                        <button
                            key={star}
                            type="button"
                            role="radio"
                            aria-checked={selected === star}
                            aria-label={`${star} de 10`}
                            className={`task-grade__star${active ? ' is-active' : ''}`}
                            disabled={disabled}
                            onMouseEnter={() => setHover(star)}
                            onFocus={() => setHover(star)}
                            onBlur={() => setHover(0)}
                            onClick={() => setGrade(star)}
                        >
                            <Icon />
                        </button>
                    );
                })}
                <span className="task-grade__value" aria-live="polite">
                    {selected ? `${selected} / 10` : 'Sin calificar'}
                </span>
            </div>

            {error ? (
                <p className="task-grade__error" role="alert">{error}</p>
            ) : null}
        </div>
    );
};
